import { composeIO } from 'react-compose-io'
import { itemCicloPendenteListaIO } from './ItemCicloPendenteLista.IO'
import { ItemCicloPendenteListaView } from './ItemCicloPendenteLista.View'

export const ItemCicloPendenteLista = composeIO(ItemCicloPendenteListaView, itemCicloPendenteListaIO)
